/* eslint-disable react/no-array-index-key */
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import currencyFormat from 'src/utils/formatCOP';
import arrayGroupBy from 'src/utils/arrayGroupBy';
import arrayFixerObjects from 'src/utils/arrayFixerObjects';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';

const TableMonthsCompanies = ({
  array = [], title = '', param, order, sizeHeader = 2,
}) => {
  const arrayRender = arrayFixerObjects(array, param, order);

  // normalizo los segmentos
  const orderParams = array.reduce((newArray, a) => {
    const found = newArray.find((paramTitle) => paramTitle === a[order]);
    if (found === undefined) newArray.push(a[order]);
    return newArray;
  }, []);

  // normalizo los segmentos
  const orderCompanys = array.reduce((newArray, a) => {
    const found = newArray.find((company) => company === a[param]);
    if (found === undefined) newArray.push(a[param]);
    return newArray;
  }, []);

  // normalizo el tamaño del segmento
  let tableArray = [];
  tableArray = arrayGroupBy(arrayRender, param);
  // tableArray.forEach((value, index) => {
  //   orderParams.forEach(parameter => {
  //     const found = value.findIndex(item => item.SEGMENTO === parameter)
  //     if (found === -1) {
  //       tableArray[index].push({
  //         [param]: value[0][param],
  //         [order]: parameter,
  //         CANT: 0,
  //       })
  //     }
  //   })
  // })

  const classes = useStyles();
  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="spanning table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              {orderCompanys.map((row) => (
                  <StyledTableCell colSpan={sizeHeader} align="center" key={row}>
                    {row}
                  </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {orderParams.map((rowTitle, index) => (
              <TableRow key={Math.random()}>
                <TableCell align="left">{rowTitle.toUpperCase()}</TableCell>
                {tableArray.map((cell, i) => (
                  <React.Fragment key={i}>
                    <TableCell align="right" >
                      {currencyFormat(parseInt(cell[index].CANT || cell[index].USD, 10))}
                    </TableCell>
                  </React.Fragment>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableMonthsCompanies;
